export default function UnstakeTab({
  tokenSymbol,
  value,
  handleChange,
  openModal,
  availableStakes = {},
  setValue,
  restakeAmountETH,
}) {
  const rawAmountETH = Number(availableStakes?.amountETH || 0);
  const restaked = Number(restakeAmountETH || 0);
  const claimCountdown = availableStakes?.claimCountdown || "00D:00H:00M";

  // ✅ Determine if claim countdown has passed
  const isClaimCountdownPassed = claimCountdown === "00D:00H:00M";

  // ✅ Calculate available amount — ensure it's never negative and if less then 1e-12 it stays 0
  const EPSILON = 1e-4;

  let amountETH = rawAmountETH - (!isClaimCountdownPassed ? restaked : 0);
  if (Math.abs(amountETH) < EPSILON || amountETH < 0) amountETH = 0;
  // amountETH = Number(amountETH.toFixed(DISPLAY_DECIMALS));


  // let amountETH = rawAmountETH - (!isClaimCountdownPassed ? restaked : 0);
  // if (amountETH < 0) amountETH = 0; // ✅ Prevent negative available values

  const numericValue = Number(value?.toString().replace(/,/g, ""));
  const numericAvailable = amountETH;

  const isDisabled =
    !numericValue ||
    numericValue <= 0 ||
    numericValue > numericAvailable;

  const formatNumber = (num, decimals = 4) => {
    if (isNaN(num)) return "0";
    return Number(num).toLocaleString(undefined, {
      maximumFractionDigits: decimals,
    });
  };

  return (
    <div className="top_one">
      {/* Header Section */}
      <div className="inner_top">
        <h3>Enter Unstaking Amount</h3>
        <div className="available_info">
          <h4>
            Available:{" "}
            <span>{`${formatNumber(amountETH, 4)} ${tokenSymbol}`}</span>
          </h4>
        </div>
      </div>

      {/* Input Section */}
      <div className="input_div">
        <input
          type="text"
          value={value}
          onChange={handleChange}
          placeholder="0.00"
        />

        {/* MAX Button */}
        <div
          className="inter_div"
          onClick={() => setValue(amountETH > 0 ? amountETH.toString() : "0")}
          style={{ cursor: numericAvailable > 0 ? "pointer" : "not-allowed" }}
        >
          <span>MAX</span>
          <div className="inter_text">
            <h5 className="outter_sec">{tokenSymbol}</h5>
          </div>
        </div>
      </div>

      {/* Unstake Button */}
      <button
        onClick={() => openModal("unstakeFinalize")}
        disabled={isDisabled}
        style={{
          opacity: isDisabled ? 0.6 : 1,
          cursor: isDisabled ? "not-allowed" : "pointer",
        }}
      >
        Unstake
      </button>

      {/* Countdown Info */}
      {!isClaimCountdownPassed &&
        restakeAmountETH &&
        restakeAmountETH !== "0" && (
          <p className="text-sm text-gray-400 mt-2">
            You can claim restaked amount after countdown: {claimCountdown}
          </p>
        )}
    </div>
  );
}
